import {ApiEndpoints} from 'src/shared/constants/apiEndpoints';
import ApiCaller from 'src/shared/utils/ApiCaller';

export interface PresignAndUploadArgs {
  filename: string;
  /** Content type declared to the presign endpoint. */
  presignContentType: string;
  blob: Blob;
  /** Content type sent on the S3 PUT. */
  uploadContentType: string;
  heartbeat: () => Promise<void>;
}

export interface PresignAndUploadResult {
  accessUrl: string;
  key: string;
}

// Presigns then PUTs a blob to S3, keeping the outbox claim alive with a 30s
// heartbeat so a slow upload isn't reclaimed mid-transfer by another tab.
export const presignAndUploadBlob = async ({
  filename,
  presignContentType,
  blob,
  uploadContentType,
  heartbeat,
}: PresignAndUploadArgs): Promise<PresignAndUploadResult> => {
  const presign = await ApiCaller({
    method: 'POST',
    endpointURL: ApiEndpoints.uploadFile,
    data: {filename, type: presignContentType},
  });
  const {uploadUrl, accessUrl, key} = presign.data;

  await heartbeat();
  const timer = setInterval(() => void heartbeat(), 30_000);
  try {
    await ApiCaller({
      method: 'PUT',
      endpointURL: '',
      data: blob,
      contentType: uploadContentType,
      customEndpointURL: uploadUrl,
    });
  } finally {
    clearInterval(timer);
  }
  await heartbeat();

  return {accessUrl, key};
};
